import { MutationTree } from 'vuex';
import { BreadcrumbItem, BreadcrumbState } from '../types';

export const breadcrumbMutations: MutationTree<BreadcrumbState> = {

  clear(state) {
    state.items = [];
  },

  updateItems(state, payload?: BreadcrumbItem[]) {
    state.items = (payload || []).map((breadcrumb: any) => ({
      ...breadcrumb,
      exact: true
    }));
  },

};
